<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap thank-you"
  >
    <div class="header">
      {{ $t('preCheckIn.thankYou.header') }}
    </div>
    <h3>
      {{ $t('preCheckIn.thankYou.title') }}
    </h3>
    <h4>
      {{ $t('preCheckIn.thankYou.info') }}
    </h4>
    <el-row class="block">
      <el-row class="title">
        {{ $t('preCheckIn.thankYou.formTitle') }}
      </el-row>
      <el-row
        v-if="typeof appData.clinic !== 'undefined'"
        class="app-details-info"
      >
        <div class="date-time wrap">
          <i class="fas fa-clock fa-lg" />
          <span>
            {{ day }}, {{ date }}
            <br>
            {{ dt }}
          </span>
        </div>
        <div class="address wrap">
          <i class="fas fa-map-marker-alt fa-lg" />
          <span>
            {{ appData.clinic.Line1 }}
            <br>
            {{ appData.clinic.City }}, {{ userData.address.state }} {{ appData.clinic.Zip }}
          </span>
        </div>
      </el-row>
      <el-row class="add-to-calendar">
        <el-link
          class="btn-calendar"
          @click="downloadEvent"
        >
          <i class="far fa-calendar-check fa-lg" />
          {{ $t('common.buttons.calendar') }}
        </el-link>
      </el-row>
    </el-row>
    <el-row
      v-if="phone"
      class="call-info"
    >
      {{ $t('preCheckIn.thankYou.call') }}
      <el-link
        :href="'tel:1' + phoneLink"
      >
        {{ phone }}
      </el-link>
    </el-row>
  </el-row>
</template>
<script>

import Vue from 'vue'
import store from "../../store";
import moment from 'moment';
import ICS from 'vue-ics';

Vue.use(ICS);
export default {
  name: 'ThankYou',
  data: () => {
    return {
      userData: {},
      appData: {},
      fullscreenLoading: false,
      patientNumber: null,
      loading: false,
      isLoading: false,
      phone: null,
      phoneLink: null,
      day: null,
      date: null,
      dt: null,
      activeStep: null,
      languages: ['en', 'es'],
      locale: '',
      defaultLocale: 'en'
    };
  },

  created () {
    this.fullscreenLoading = true;
    let pathData = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    this.locale = (this.languages.includes(pathData[0])) ? pathData[0] : this.defaultLocale;
    this.setProgressBar();
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.setData();
        this.patientNumber = this.userData.patientNumber;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    downloadEvent(){
      this.$ics.download('Appointment', '.ics');
    },
    setData() {
      this.saveStatisticData(this.getSessionId(), {
        active_step: this.activeStep,
        render_ThankYou : 'true'
      });
      this.userData = store.getters.patientData;
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      });
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
        pid: this.userData.patientId
      }).then((response) => {
        if (response.data) {
          this.$set(this, 'appData', response.data.appData);
          moment.locale(this.locale);
          this.day = moment(this.appData.dateTime).format('dddd');
          moment.locale(this.defaultLocale);
          this.date = moment(this.appData.dateTime).format('M/D/Y');
          this.dt = moment(this.appData.dateTime).format('LT');
          this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getServiceCenterData', {
            clinicId: this.appData.parentClinicId
          }).then((response) => {
            if (response.data.isSuccess) {
              this.$set(this.appData, 'clinic', response.data.data);
              this.appData.clinic.Zip.substr(0, 5);
              this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getClinicOptions').then((response) => {
                if (response.data.isSuccess) {
                  this.$set(this, 'phone', response.data.data.phone);
                  this.$set(this, 'phoneLink', this.phone.replace(/[^0-9]/g, ''));

                  let clinicName = response.data.data.title,
                      begin = this.appData.dateTime,
                      stop = new Date(new Date(begin).getTime() + 60 * 60000),
                      place = this.appData.clinic.Line1 + ' ' + this.userData.address.state + ' ' + this.appData.clinic.Zip;

                  this.$ics.addEvent('en-us', clinicName + ' Appointment', 'Appointment in ' + clinicName, place, begin, stop);
                  this.fullscreenLoading = false;
                } else {
                  this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.thankYou.labels.clinicData') }));
                  this.fullscreenLoading = false;
                }
              }).catch(() => {
                this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.thankYou.labels.clinicData') }));
                this.fullscreenLoading = false;
              });
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.get', { type: this.$t('preCheckIn.thankYou.labels.clinicName') }));
            this.fullscreenLoading = false;
          });
        }
      }).catch(() => {
        this.setMessage(this.$t('common.errors.data'));
        this.fullscreenLoading = false;
      });
    }
  }
};
</script>
